define('threadsListView',[
    'app',
    'module',
    'marionette',
    'underscore',
    'threadsListSearchView',
    'threadsListThreadsView',
    'mailsListLabelsFilterView',
    'template!threadsListView'
], function (
    App,
    Module,
    Marionette,
    _,
    SearchView,
    ThreadsView,
    LabelsFilterView,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'list-view',

        regions: {
            labelsFilterRegion: '.labels-filter-region',
            searchRegion: '.search-region',
            threadsRegion: '.threads-region'
        },

        initialize: function() {
            this.threadsView = new ThreadsView({
                parentView: this
            });

            // Alias so the reused LabelsFilterView can find mailSecId
            this.mailsView = this.threadsView;

            this.searchView = new SearchView({
                parentView: this
            });
            this.searchView.on('search', this.onSearch, this);

            this.labelsFilterView = new LabelsFilterView({
                parentView: this
            });
            this.labelsFilterView.on('filter:labels', this.onFilterLabels, this);
            this.labelsFilterView.on('filter:clear', this.onClearLabelsFilter, this);
        },

        onRender: function() {
          this.getRegion('threadsRegion').show(this.threadsView);
          this.getRegion('searchRegion').show(this.searchView);
          this.getRegion('labelsFilterRegion').show(this.labelsFilterView);
        },

        onSearch: function(value) {
            this.threadsView.search(value);
        },

        onFilterLabels: function(selectedLabels) {
            this.threadsView.filterByLabels(selectedLabels);
        },

        onClearLabelsFilter: function() {
            this.threadsView.clearLabelsFilter();
        }
    });
});

